var map = {
	"./asda/default-messages": 141,
	"./electrodeio/default-messages": 142,
	"./samsclub/default-messages": 143,
	"./walmart/default-messages": 144
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 140;



//////////////////
// WEBPACK FOOTER
// ./src/lang/tenants ^\.\/.*\/default\-messages$
// module id = 140
// module chunks = 0